import script from "./TransactionSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionSuccess.vue?vue&type=script&setup=true&lang=js"

import "./TransactionSuccess.vue?vue&type=style&index=0&id=70c6cad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c6cad2"]])

export default __exports__